const strings = {
  abcya: ["ABCya"],
  about: {
    title: ["ACERCA DE ABCya", "Acerca de ABCya", "ACERCA DE ABCYA"],
  },
  adblock: {
    content: "¿No puedes ver el ^? Inténtalo tras desactivar el bloqueador de anuncios.",
  },
  ads: {
    ad: "Anuncio",
    go: "¡Di adiós a los anuncios!",
  },
  ageGate: {
    message: "Para continuar, ingresa tu fecha de nacimiento.",
    title: "Adultos",
    select: {
      year: "AAAA",
      day: "DD",
      month: "MM",
    },
  },
  all: ["TODOS", "Todos"],
  // applied: "ACTIVADO",
  // apply: "ACTIVAR",
  appStores: {
    AMAZON: "Amazon Appstore",
    ANDROID: "Google Play Store",
    IOS: "Apple App Store",
  },
  attention: ["Atención"],
  back: ["VOLVER"],
  browse: ["explorar"],
  browseLibrary: "EXPLORA NUESTRA COLECCIÓN",
  cancel: ["cancelar", "Cancelar", "Cancelando", "Cancelado", "CANCELAR"],
  categoryGames: {
    title: "Categoría de juegos",
  },
  checkPass: "Verificando la contraseña",
  choose: ["ELEGIR"],
  classroom: "Clase",
  contact: ["Contáctanos", "CONTÁCTANOS"],
  continue: ["CONTINUAR"],
  cookieBanner: {
    title: "Privacidad y cookies de ABCya",
    message:
      'ABCya utiliza cookies para ofrecer la mejor experiencia posible. Para aprender más, lee nuestra <a href="/privacidad">Política de Privacidad</a>.',
    shortname: "haz-una-galleta",
  },
  copyright: "Copyright ^ ABCya.com, L.L.C., una división de IXL Learning • Todos los derechos reservados",
  cost: ["Costo"],
  currencySymbol: {
    usd: "$",
  },
  delete: ["Eliminando", "Eliminado"],
  dismiss: ["DESCARTAR"],
  done: ["ACEPTAR"],
  education: {
    title: "Education.com",
  },
  educatorInfo: "Información para educadores",
  educatorInfoErrorMessage: "Se produjo un error al mostrar la información para educadores: ^",
  emailPreferences: {
    form: {
      subscribe: "Recomendaciones de juegos",
      unsubscribe: "Darse de baja de todos los emails",
    },
    instructions: "Elige qué emails quieres recibir de ABCya:",
    manage: {
      button: "Preferencias de email",
    },
    notFound: `Tus preferencias de email están aún sin configurar. Por favor, inténtalo más tarde o contacta con el servicio al cliente en <a href="mailto:soporte@abcya.com" rel="noopener noreferrer" target="_blank">soporte@abcya.com</a>.`,
    success: {
      title: {
        subscribed: "Alta tramitada correctamente",
        unsubscribed: "Baja tramitada correctamente",
      },
      message: {
        subscribed: "Tus preferencias de email se han guardado correctamente.",
        unsubscribed: "Tu baja de nuestros emails se ha tramitado correctamente.",
      },
    },
    title: ["PREFERENCIAS DE EMAIL", "Preferencias de email"],
  },
  emmersion: {
    title: "Emmersion",
  },
  error: ["ERROR"],
  expire: ["vencerá"],
  externalServiceDown:
    "En estos momentos estamos experimentando dificultades técnicas y es posible que algunos elementos, como el inicio de sesión o el registro, no funcionen. Pedimos disculpas por las molestias ocasionadas. Estamos trabajando para restablecer la funcionalidad plena.",
  family: "Familia",
  faq: {
    feedback: {
      cta: "¡Nos encanta recibir comentarios de nuestra comunidad! Por favor, danos una explicación detallada, cuanta más información nos proporciones, más fácil nos resultará ayudarte.",
      error: {
        message: ["¡Lo siento! Tu mensaje no ha sido enviado."],
      },
      game: "¿Tienes problemas con algún juego en particular?",
      question: "¿No encontraste una respuesta? Contáctanos.",
      success: {
        message: [
          "¡Gracias! Tu mensaje ha sido enviado. En breve nos pondremos en contacto contigo.",
          "¡Gracias! Tu mensaje ha sido enviado. Nos pondremos en contacto contigo en la dirección de email asociada a tu cuenta de ABCya.",
        ],
        title: "Mensaje enviado",
      },
      terms:
        'Al hacer clic en ENVIAR, declaras que has leído y aceptado nuestra <a href="/privacidad" rel="noopener noreferrer" target="_blank">Política de Privacidad</a>.',
      title: ["Mensaje", "Comentarios y preguntas", "comentarios y preguntas"],
    },
    title: ["AYUDA / Preguntas frecuentes", "Preguntas frecuentes"],
  },
  first: ["PRIMERO"],
  footer: {
    affiliate: "Socios",
    content: "NUESTROS CONTENIDOS",
    featured: {
      title: "ABCya ha aparecido en",
      outlets: ["The New York Times", "Apple", "USA Today", "Parents", "Scholastic", "Fox News"],
    },
    games: ["Juegos de ^", "Juegos para el grado ^"],
    brands: {
      ixl: "Aprendizaje personalizado exhaustivo para la educación K-12",
      rosetta: "Aprendizaje de inmersión para 25 lenguas",
      vocabulary: "Aprendizaje adaptativo para el vocabulario de inglés",
      education: "Más de 35,000 hojas de ejercicios, juegos y planes de clase",
      wyzant: "Tutores de confianza para más de 300 materias",
      spanishIngles: "Diccionario inglés-español, traductor y sitio de aprendizaje",
      emmersion: "Certificación de lengua rápida, fácil y fiable",
      tpt: "Un mercado de millones de recursos creados por educadores",
    },
    languageMenu: {
      en: "Browse in English",
    },
  },
  forgot: {
    caption: [
      "Para restablecer tu contraseña, ingresa la dirección de email asociada a tu cuenta.",
      "<p>Las instrucciones para restablecer la contraseña se han enviado a tu email.</p><p><strong>Si no encuentras el email en tu bandeja de entrada, por favor, revisa tu carpeta de correo no deseado/spam.</strong></p>",
    ],
    loading: "Enviando solicitud para restablecer contraseña",
    metaTitle: "Olvidé la contraseña",
    subtitle: "Enviar email para restablecer contraseña",
    title: "OLVIDÉ LA CONTRASEÑA",
  },
  forms: {
    accessCode: "Código de acceso",
    accessName: "Nombre de acceso",
    answer: "Respuesta",
    city: ["Ciudad"],
    code: ["Código", "Código temporal", "código"],
    country: ["País"],
    currentPassword: "Contraseña actual",
    deviceCount: ["Número de dispositivos", "Número de Dispositivos"],
    email: [
      "Dirección de Email",
      "Dirección de email / Nombre de acceso",
      "Dirección de email",
      "Email",
      "Dirección de email del adulto",
      "dirección de email del adulto",
      "El campo de dirección de email",
      "El campo de dirección de email del adulto",
      "dirección de email",
    ],
    teacherEmail: [
      "Dirección de email del docente",
      "dirección de email del docente",
      "El campo de dirección de email del docente",
    ],
    emailVerify: "Confirmar email",
    adultEmailVerify: "Confirmar email",
    teacherEmailVerify: "Confirmar email del docente",
    feedback: "Comentarios",
    getAQuote: "OBTENER UN PRESUPUESTO",
    name: ["Nombre"],
    newPassword: ["Nueva contraseña", "La nueva contraseña", "nueva contraseña", "El campo de nueva contraseña"],
    newPasswordVerify: "Verificar contraseña",
    password: [
      "Contraseña",
      "Contraseña / Código de acceso",
      "Crear contraseña",
      "contraseña",
      "El campo de contraseña",
    ],
    passwordVerify: "Confirmar contraseña",
    phone: ["Número de teléfono", "Número de Teléfono"],
    position: ["Puesto"],
    schoolAddress: ["Dirección de la escuela", "Dirección de la Escuela"],
    schoolName: ["Nombre de la escuela", "Nombre de la Escuela"],
    select: ["Seleccionar..."],
    state: ["Estado o provincia"],
    studentCount: ["Número de estudiantes", "Número de Estudiantes"],
    yourContact: "Tu información de contacto",
    yourDistrictSchool: "Tu escuela/distrito",
    errorMessages: {
      email: ["^ debe contener una dirección de email válida."],
      mustMatch: ["^ debe coincidir en los dos campos.", "La ^ debe coincidir en los dos campos."],
      isRequired: ["^ es obligatorio.", "El campo de ^ es obligatorio."],
      isTooLong: "^ debe tener como máximo ^ caracteres.",
      isTooShort: "^ debe tener como mínimo ^ caracteres.",
      nonAlphaNumericHyphenUnderscore:
        "^ solo puede contener letras minúsculas, números y guiones bajos, y no debe incluir espacios.",
    },
  },
  free: ["Gratuito", "GRATIS"],
  freeGames: {
    title: "Juegos gratuitos de la semana",
    subtitle: "Vuelve cada semana para descubrir seis juegos nuevos GRATIS",
  },
  game: {
    favorites: {
      add: "Añadir a Favoritos",
      adding: "Añadiendo a Favoritos",
      mine: "¡Mi favorito!",
      publicLimit: [
        "¿Quieres añadir más juegos favoritos? ¡Adquiere tu membresía!",
        "¿Quieres añadir más juegos favoritos?",
      ],
      remove: "Eliminar de Favoritos",
      removing: "Eliminando de Favoritos",
      signup: "¡Suscríbete para guardar todos tus juegos favoritos!",
    },
    fullscreen: {
      incompatible: {
        message:
          "El navegador que estás utilizando no es compatible con el modo de pantalla completa. Por favor, inténtalo con otro navegador.",
        title: "Navegador incompatible",
      },
      signup: "¡Suscríbete para disfrutar de tus juegos favoritos en modo de pantalla completa!",
      title: ["Pantalla completa"],
      upgrade: "Adquiere tu membresía para disfrutar de tus juegos favoritos en modo de pantalla completa",
    },
    go: "Ir a la página “Todos los juegos”",
    mobile: {
      exit: "¿Salir?",
      find: "Buscar juegos para dispositivos móviles",
      notAvailable: "Lo sentimos, este juego aún no está disponible para dispositivos móviles.",
      play: "¡DISFRUTA DE TODOS NUESTROS JUEGOS EN UNA COMPUTADORA DE ESCRITORIO SIEMPRE QUE QUIERAS!",
    },
    similar: "JUEGOS PARECIDOS",
    title: ["juego", "Juego", "JUEGO"],
    trouble: "¿Te está dando problemas este juego?",
    educatorInfo: {
      skills: "Habilidades que se practican",
      recommended: "Recomendado para:",
      info: "Información sobre el juego",
      warmUp: "Actividades previas sugeridas",
      followUp: "Actividades de seguimiento sugeridas",
    },
  },
  games: {
    all: ["TODOS LOS JUEGOS", "visita “Todos los juegos”"],
    title: ["Juegos", "JUEGOS"],
    by: "Juegos agrupados por ^",
  },
  giftcard: {
    // another: "Activar otra tarjeta de regalo",
    // applying: "Activando tarjeta de regalo",
    checking: "Verificando tarjeta de regalo",
    choose: {
      amount: {
        enter: "Ingresar cantidad",
        rules: "La cantidad mínima es de $10 y la máxima de $500; la cantidad solo puede incrementarse de $5 en $5.",
        title: "Elegir cantidad:",
      },
      design: "Elegir el modelo de tarjeta de regalo",
    },
    claim: {
      example: "XXXXXXXXXXXXXXXX",
      title: "Código de canje:",
    },
    complete: "COMPLETAR COMPRA",
    confirm: {
      message: "Compra de tarjeta(s) de regalo",
      recipients: "Destinatario(s)",
      design: "Modelo",
    },
    details: "Datos de la tarjeta de regalo",
    disclaimer: "Las tarjetas de regalo no son reembolsables.",
    emailError: "El campo de email del destinatario",
    errors: {
      // applied: "El código de la tarjeta de regalo facilitado ya ha sido activado",
      invalid: "El código de la tarjeta de regalo facilitado no es válido",
      // max: "La cantidad de la tarjeta de regalo supera el importe máximo de canje de $^",
      redeemed: "El código de la tarjeta de regalo facilitado ya ha sido canjeado.",
    },
    from: {
      email: ["Tu email", "email", "dirección de email", "El campo de email"],
      name: ["Tu nombre", "nombre"],
      title: "De:",
    },
    message: "Mensaje:",
    messageError: "Mensaje de la tarjeta de regalo ^",
    optional: "(Opcional)",
    preview: "VISTA PREVIA DE TARJETA(S)",
    purchase: ["ADQUIRIR TARJETAS DE REGALO", "ADQUIRIR TARJETA(S)", "Adquirir tarjetas de regalo"],
    quantity: "Cantidad",
    recipientEmail: "Email del destinatario:",
    redeem: ["CANJEAR TARJETAS DE REGALO", "Canjear tarjetas de regalo", "CANJEAR"],
    redeemed: ["Tus códigos de tarjeta de regalo han sido canjeados."],
    subtitle: "Tarjeta de regalo de ABCya",
    success: {
      message: {
        contact: 'Por favor, no dudes en <a href="/soporte">contactarnos</a> si tienes alguna pregunta.',
        receipt: "Se enviará un recibo por email con la(s) tarjeta(s) de regalo a ^.",
        recipients: "La(s) tarjeta(s) de regalo de $^ también se enviará(n) a ^.",
      },
      title: "¡Gracias por adquirir una tarjeta de regalo de ABCya!",
    },
    title: ["¡Regala ABCya!", "TARJETA DE REGALO", "Tarjeta de regalo"],
    total: ["Total de las tarjetas de regalo activadas: ^", "Total de la(s) tarjeta(s) de regalo:"],
  },
  grade: ["GRADO", "grado", "Grado", "Grados"],
  grades: {
    categories: {
      holiday: "JUEGOS DE FESTIVIDADES DE ^",
      letters: "JUEGOS DE PALABRAS DE ^",
      numbers: "JUEGOS DE MATEMÁTICAS DE ^",
      skill: "JUEGOS DE HABILIDAD DE ^",
      strategy: "JUEGOS DE ESTRATEGIA DE ^",
    },
    sorry: "Lo siento, aún no hay juegos para este grado. ¡Por favor, vuelve a intentarlo en breve!",
    title: "GRADO ^",
    featured: "juegos destacados",
    minibanner: "Grados ^ – ^",
    pre: "pre",
  },
  head: {
    defaultTitle: "ABCya • Juegos divertidos en español para niños",
    description:
      "¡Explora nuestros superdivertidos juegos en español! Los estudiantes aprenden mientras se divierten con nuestros entretenidos juegos educativos de lectura, matemáticas, letras, números y mucho más. ¿Quieres aprender con juegos gratis para niños? Nuestros divertidos juegos son justo lo que estás buscando... ¡y son totalmente gratis!",
    keywords:
      "niños, educativo, juegos, apps, aplicaciones, primaria, escuela primaria, educación primaria, matemáticas, ortografía, lectura, letras, números, práctica",
    schemaTitle: "ABCya • ^",
    titleTemplate: "%s • ABCya",
  },
  help: {
    title: ["AYUDA", "Ayuda"],
  },
  gameCategoryGroups: {
    genre: "tipo",
    subject: "materia",
    theme: "tema",
  },
  internetExplorer: "ABCya ya no es compatible con Internet Explorer. Por favor, utiliza otro navegador.",
  ixl: {
    title: "IXL",
  },
  join: [
    "¡Únete ya!",
    "¡Únete ya!",
    "ÚNETE YA",
    "¡ÚNETE YA!",
    "¡Únete ya!",
    "¡ÚNETE YA!",
    "ÚNETE ya",
    "¡Desbloquea más juegos!",
    "¡Únete para jugar!",
  ],
  last: ["ÚLTIMO"],
  leaving: {
    message: "Ahora estás saliendo de ABCya.com.",
    cta: "¿Quieres continuar?",
    disclaimer:
      "Al acceder a este enlace, abandonarás nuestro sitio web y serás redirigido a un sitio web perteneciente a otra entidad. Te informamos de que ya no estarás sujeto a nuestras políticas de privacidad y seguridad, ni bajo su protección. ABCya no se hace responsable de la información, contenido o producto(s) hallados en sitios web de terceros.",
  },
  loading: "cargando...",
  login: {
    forgot: "Olvidé la contraseña",
    invalid: {
      title: "¡Se ha cerrado tu sesión!",
      description: "Se ha cerrado tu sesión. Por favor, inicia sesión de nuevo para seguir jugando.",
    },
    legacy: "Canjear antigua suscripción de ABCya Juegos",
    loading: "Iniciando sesión",
    notSubscriber: "¿No tienes una cuenta?",
    outConfirm: "¿De verdad quieres cerrar sesión en ABCya.com?",
    title: "Acceso a la cuenta",
    /* premium: {
      required:
        "Se requiere una membresía para acceder a este contenido. Por favor, inicia sesión o suscríbete para continuar.",
    }, */
    metaTitle: "Apps y juegos divertidos en español para niños",
  },
  manage: {
    accountInfo: {
      current: "actual:",
      student: {
        autoURL: "url de inicio de sesión automático:",
      },
      success: "La información de tu cuenta ha sido actualizada.",
      title: ["MODIFICAR INFORMACIÓN DE CUENTA", "Modificar información de cuenta"],
      ixlSchoolContactCta:
        "Para modificar la información de tu cuenta, por favor, <a href='mailto:sales@abcya.com'>ponte en contacto con el equipo de ventas.</a>",
    },
    cancel: {
      canceled: "Tu suscripción ya ha sido cancelada y pasará a ser un plan gratuito el ^.",
      password: "Si deseas cancelar tu suscripción, por favor, ingresa tu contraseña actual.",
      success: "Tu ^ ha sido cancelada y pasará a ser un plan gratuito el ^.",
      title: ["CANCELAR SUSCRIPCIÓN", "Cancelar suscripción"],
      warning: "Tu cuenta de pago se cancelará al final del período de facturación actual, es decir, el ^.",
    },
    close: {
      title: ["ELIMINAR CUENTA"],
    },
    delete: {
      password: "Si aún deseas eliminar permanentemente tu cuenta, por favor, ingresa tu contraseña actual.",
      success: "Tu cuenta ha sido eliminada. Ya no podrás iniciar sesión.",
      title: ["ELIMINAR CUENTA", "Eliminar cuenta"],
      warning:
        "Al eliminar tu cuenta, la información que tenemos en nuestra base de datos se borrará de forma permanente y, a partir de ese momento, no te resultará posible volver a iniciar sesión.",
    },
    password: "Por favor, ingresa tu contraseña para realizar las actualizaciones solicitadas.",
    payment: {
      credit: "Actualizar tarjeta de crédito",
      success: "Tu información de pago ha sido actualizada.",
      title: ["ACTUALIZAR INFORMACIÓN DE PAGO", "Actualizar información de pago"],
    },
    subscription: {
      balance: "Saldo de la cuenta: ^",
      messages: {
        free: "Actualmente tienes una cuenta gratuita.",
        invoiced: [
          'Para obtener ayuda o información adicional sobre tu cuenta, por favor, envíanos un email a <a href="mailto:soporte@abcya.com" rel="noopener noreferrer" target="_blank">soporte@abcya.com</a>. ¡Estaremos encantados de ayudarte!',
        ],
        ixl: "Tu suscripción a ABCya forma parte de una membresía a IXL. Para actualizar o cancelar tu suscripción, por favor visita:",
        ixlSchool:
          "Tu suscripción a ABCya forma parte de una membresía a IXL. Para actualizar o cancelar tu suscripción, por favor <a href='mailto:sales@abcya.com'>contacta con el equipo de ventas.</a>",
        legacy: "Ten en cuenta que al modificar/actualizar tu suscripción, renunciarás al precio actual de ^ por ^.",
        native: ["Para actualizar o cancelar tu suscripción, por favor visita:"],
        web: ["Para modificar tu plan de suscripción, debes tener una tarjeta de crédito registrada."],
      },
      renew: "Tu ^ se ^ el ^",
      success: {
        free: {
          instructions:
            "Ahora se cerrará la sesión y volverás a nuestra página de inicio. ¡Por favor, inicia sesión de nuevo para empezar a disfrutar de los beneficios de tu membresía!",
          upgraded: "¡Tu plan gratuito ha pasado a ser un ^!",
        },
        generic: "Tu suscripción ha sido actualizada.",
        premium: "Tu ^ ha sido actualizado.",
      },
      title: ["ADMINISTRAR SUSCRIPCIÓN", "Administrar suscripción"],
    },
    title: ["ADMINISTRAR CUENTA", "Administrar cuenta"],
    update: {
      prompt: "Por favor, ingresa tu contraseña actual.",
    },
  },
  mobileAppDownload: {
    title: "ABCya is better in the app!",
    noAds: "Play games with no ads",
    download: "Download games for offline play",
    smooth: "Enjoy smoother gameplay",
    continue: {
      app: "CONTINUE IN THE APP",
      browser: "Continue in browser",
    },
  },
  months: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre",
  ],
  navigation: {
    close: ["CERRAR"],
    download: ["Descargar"],
    fullscreen: {
      exit: "Salir del modo de pantalla completa",
      go: "Acceder al modo de pantalla completa",
    },
    login: ["Iniciar sesión", "INICIAR SESIÓN"],
    logout: ["Cerrar sesión", "CERRAR SESIÓN", "Cerrar Sesión"],
    menu: "Menú",
    print: ["Imprimir", "IMPRIMIR"],
    search: "Buscar",
    open: ["Abrir"],
    more: ["Leer más >", "Mostrar más"],
    top: ["Ir arriba"],
  },
  new: ["¡NUEVO!"],
  next: ["SIGUIENTE"],
  no: ["No"],
  none: ["NINGUNO"],
  notfound: {
    gohome: "Ir a la página de inicio",
    sorry: "Lo siento, no se pudo encontrar ese ^.",
    title: "¡Ups! No se encontró",
    item: "contenido",
  },
  off: ["DESACTIVADO", "DESACTIVADA"],
  ok: "OK",
  on: ["ACTIVADO", "ACTIVADA"],
  onboarding: {
    welcome: "¡TE DAMOS LA BIENVENIDA!",
    userType: {
      ads: "Elimina los anuncios por completo",
      notNow: "Ahora no",
      play: "Juega juegos ilimitados en línea y sin conexión",
      subtitle: {
        family: "ABCya prémium hace que el aprendizaje sea divertido para toda la familia.",
        teacher: "ABCya prémium hace que el aprendizaje sea divertido para toda tu clase.",
      },
      unlock: {
        amount: {
          family: "5",
          teacher: "30",
        },
        copy: "Desbloquea el acceso de suscriptor para hasta ^ dispositivos",
      },
    },
    using: {
      subtitle: "¿Quién está usando ABCya?",
      teacher: "Docente",
      parent: "Madre/Padre",
      student: "Estudiante",
    },
  },
  parent: ["PADRE O MADRE"],
  parentsTeachers: {
    recentBlogs: "Entradas recientes del blog",
    title: ["PADRES Y DOCENTES", "Padres y docentes"],
    visit: "Visita el blog",
  },
  password: {
    caption: [
      "Ingresa una nueva contraseña y verifícala para actualizar tu cuenta.",
      "Tu contraseña ha sido actualizada.",
    ],
    codecta: "Copia y pega el código temporal del correo electrónico que recibiste.",
    loading: "Actualizando contraseña",
    metaTitle: "Actualizar contraseña",
    title: "ACTUALIZAR CONTRASEÑA",
    toggle: "Haz clic para mostrar/ocultar la contraseña",
  },
  payterms: {
    title: ["CONDICIONES DE PAGO", "Condiciones de Pago"],
  },
  plan: ["Plan"],
  playInLocale: ["PLAY IN ENGLISH", "Play in English"],
  print: {
    alt: "Imagen imprimible de ABCya",
    cleanMessage: {
      message: "Después de imprimir, es posible que necesites hacer clic en la imagen para volver al contenido.",
    },
    defaultFile: "ABCya_archivoParaImprimir",
    pdfMessage: {
      message: {
        download:
          "Tu navegador no permite la impresión de documentos en formato PDF. Haz clic en el botón “Descargar” para descargar el archivo PDF. Así podrás imprimir el archivo directamente desde tu lector de PDF.",
        abrir:
          "Tu navegador no permite la impresión de documentos en formato PDF. Haz clic en el botón “Abrir” para abrir el archivo PDF en otra ventana o pestaña. Una vez allí, podrás imprimir o guardar el archivo directamente desde el lector de PDF.",
      },
    },
    saveMessage: {
      message:
        "Tu navegador no permite la descarga desde páginas web. Haz clic en el botón “Abrir” para abrir el archivo en otra ventana o pestaña. Una vez allí, podrás guardar o imprimir el archivo directamente desde el navegador.",
    },
    error: {
      sorry: "¡Lo sentimos!",
      message: "Se produjo un error al imprimir o guardar.",
    },
  },
  printables: {
    title: ["recursos imprimibles", "categoría de recursos imprimibles", "recurso imprimible"],
    go: "Ir a la página “Recursos imprimibles”",
    similar: {
      games: "JUEGOS RELACIONADOS",
    },
    meta: {
      title: "Recursos imprimibles",
      description:
        "Páginas para colorear, actividades, hojas de ejercicios y recursos para docentes imprimibles de ABCya",
      keywords: "imprimible, recursos para docentes, páginas para colorear, actividades, hojas de ejercicios",
    },
  },
  privacy: {
    title: ["POLÍTICA DE PRIVACIDAD"],
  },
  promo: {
    title: ["PROMOCIÓN"],
    code: ["Código promocional"],
    applying: "Activando código promocional",
    applied: "Promoción activada",
    invalid: "La promoción no es válida o ha finalizado",
    off: "¡^ DE DESCUENTO!",
  },
  purchasing: "Procesando compra",
  redeem: {
    card: {
      anotherEmail: "PRUEBA CON OTRA DIRECCIÓN DE EMAIL",
      cta: "Por favor, ingresa tu dirección de email:",
      free: {
        disclaim:
          "<p>Las tarjetas de regalo se pueden canjear durante el proceso de registro en una cuenta prémium.</p>",
        message: {
          isLoggedIn:
            "<p>Para canjear tu tarjeta de regalo, necesitarás una suscripción a ABCya. Ve a Administrar cuenta para actualizar tu plan. Una vez que tu suscripción esté activa, podrás canjear tu tarjeta de regalo.</p>",
          loggedInDiff: `<p>Para canjear tu tarjeta de regalo, necesitarás una suscripción a ABCya. Cierra la sesión de la cuenta de ^ y vuelve a iniciar sesión con ^.</p><p>Luego, ve a Administrar cuenta para actualizar tu plan. Una vez que tu suscripción esté activa, podrás canjear tu tarjeta de regalo.</p>`,
          loggedOut:
            "<p>Para canjear tu tarjeta de regalo, necesitarás una suscripción a ABCya. Inicia sesión en ABCya.com con ^ y ve a Administrar cuenta para actualizar tu plan. Una vez que tu suscripción esté activa, podrás canjear tu tarjeta de regalo.</p>",
        },
        title: "Parece que en la actualidad dispones de una cuenta gratuita.",
      },
      friends: {
        message: '<p>Por favor, <a href="/soporte">contacta con el servicio al cliente</a>.</p>',
        title: "Parece que tienes una suscripción de amigos y familia.",
      },
      invoiced: {
        message:
          '<p>Por favor, <a href="/soporte">contacta con el servicio al cliente</a> para canjear tu tarjeta de regalo.</p>',
        title: "Parece que tienes una suscripción de pago.",
      },
      native: {
        message: `<p>Actualmente, solo los suscriptores del sitio web ABCya.com pueden canjear tarjetas de regalo de ABCya.</p>
        <p>Para canjear tu tarjeta de regalo: 
          <ol>
            <li><a href="/preguntas-frecuentes/#apps" rel="noopener noreferrer" target="_blank">Cancela tu suscripción a la aplicación móvil ABCya Juegos.</a></li>
            <li>Una vez que tu suscripción a la aplicación a través de ^ venza, inicia sesión en ABCya.com desde tu computadora de escritorio, usando las mismas credenciales que utilizaste para iniciar sesión en la aplicación ABCya Juegos.</li>
            <li>Actualiza tu cuenta en ABCya.com.</li>
            <li>Una vez que tu suscripción esté activa en el sitio web, podrás canjear tu tarjeta de regalo.</li>
          </ol>
        </p>`,
        title: "Parece que actualmente dispones de una suscripción a la app ABCya Juegos a través de ^.",
      },
      notFound: {
        message:
          "<p>^ aún no tiene una suscripción a ABCya.</p><p>¡Únete ahora para poder canjear tu tarjeta de regalo!</p>",
        title: "No reconocemos esa dirección de email.",
      },
      redeemed: {
        cta: "CANJEAR OTRA",
        message: "^ ha sido agregado a la cuenta de ^.",
        title: "¡Tarjeta de regalo canjeada!",
      },
      subtitle: "¡Vamos a añadir este crédito a tu cuenta!",
      title: "¡Hemos encontrado tu tarjeta!",
    },
    code: ["Código de tarjeta de regalo", "Ingresa tu código:"],
    title: ["¡Canjea tu tarjeta de regalo de ABCya!"],
  },
  renew: ["renovará"],
  rosetta: {
    title: "Rosetta Stone",
  },
  save: {
    defaultFile: "ABCya_guardarArchivo",
  },
  search: {
    faq: {
      answer: "Respuesta:",
      question: "^ pregunta:",
    },
    filter: "Filtrar resultados:",
    noresults: "Lo sentimos, no hay resultados de búsqueda",
    resultCounts: "^ Resultados (Página ^ de ^)",
    title: ["RESULTADOS DE BÚSQUEDA PARA: ^"],
    cta: "Buscar en ^",
  },
  searchResults: ["Resultados de búsqueda"],
  send: ["ENVIAR", "Enviando"],
  signup: ["registrarse", "REGISTRARSE"],
  spanishIngles: {
    title: "Inglés.com",
  },
  store: ["Tienda"],
  submit: ["Enviar", "ENVIAR", "Enviando"],
  subscribe: {
    accessDesc:
      "Crea un nombre de usuario y una contraseña fáciles para que tus estudiantes puedan acceder a la cuenta de ABCya.",
    complete: {
      code: "Código de finalización",
      codecta: "Copia y pega el código de finalización del email que recibiste.",
      emailcta: "Facilítanos la dirección en la que se recibió el email de finalización.",
      loading: "Completando registro",
      thankyou: {
        autologin:
          "<p>La URL de acceso automático para los estudiantes es: <strong>^</strong></p><p>La URL de acceso automático también se puede encontrar siempre que se necesite en la página “Administrar cuenta”.</p>",
        message: "¡Tu cuenta de ABCya ya está configurada!",
      },
      title: ["Completar registro de la cuenta", "COMPLETAR REGISTRO"],
    },
    confirm: {
      title: "POR FAVOR, CONFIRMA",
      message: "Estás a punto de suscribirte a:",
    },
    create: "Crear cuenta",
    creditNotRequired:
      "Se requiere la tarjeta de crédito solo si el importe del plan elegido es superior al saldo disponible en la cuenta o al total de las tarjetas de regalo activadas.",
    cta: "Elegir tipo de plan",
    desktopSignup: {
      title: "¡Desbloquea lo mejor de ABCya!",
      email: "Recibe el juego de la semana en tu bandeja de entrada",
      printable: "Accede a recursos imprimibles gratuitos",
      login: [
        '¿Ya tienes una cuenta? <a id="^" data-testid="^">Inicia sesión</a> aquí.',
        "¿Ya tienes una cuenta? Inicia sesión aquí.",
      ],
    },
    error: {
      accessNameExists: "Parece que el nombre de acceso que has elegido ya existe. Por favor, elige otro.",
      existsOnDifferentPlatform:
        "Parece que ya tienes una cuenta de ABCya, adquirida el ^. Haz clic en OK para iniciar sesión con el nombre de usuario ya existente o para recuperar tu contraseña.",
      existsOnThisPlatform:
        "Parece que ya tienes una cuenta de ABCya. Haz clic en OK para iniciar sesión con el nombre de usuario ya existente o para recuperar tu contraseña.",
      existsOnUnknownPlatform:
        "Parece que ya tienes una cuenta de ABCya, adquirida en una plataforma desconocida. Haz clic en OK para iniciar sesión con el nombre de usuario ya existente o para recuperar tu contraseña.",
      stripeInputError:
        "Error al verificar la información de la tarjeta de crédito. Por favor, inténtalo de nuevo o contacta con el servicio al cliente.",
    },
    giftcard: {
      buying: "¿Estás realizando la compra para otra persona?",
    },
    loading: "¡Uniéndote!",
    options: ["OPCIONES DE MEMBRESÍA"],
    payment: "Información sobre el pago",
    plans: {
      best: "MEJOR OFERTA",
      classroom: {
        perks: ["Sin anuncios", "Más de 100 juegos", "Hasta 30 dispositivos"],
        title: [
          "CLASE",
          "PLANES PARA LA CLASE",
          "Planes para la clase",
          "Para la clase",
          "Plan para la clase",
          "plan para la clase",
        ],
      },
      disclaimer: "Tu suscripción se renovará de manera automática. Puedes cancelarla en cualquier momento.",
      family: {
        perks: ["Sin anuncios", "Más de 100 juegos", "Hasta 5 dispositivos"],
        title: ["FAMILIA", "PLANES PARA LA FAMILIA", "Para la familia", "Plan para la familia", "plan para la familia"],
      },
      free: {
        title: ["CUENTA GRATUITA", "Cuenta gratuita", "Plan gratuito", "plan gratuito"],
      },
      m1: {
        term: "al mes",
        renewal: "mes",
        title: ["Suscripción mensual", "suscripción mensual"],
      },
      m6: {
        term: "por medio año",
        renewal: "6 meses",
        title: ["Suscripción de 6 meses", "suscripción de 6 meses"],
      },
      m12: {
        term: "por año",
        renewal: "12 meses",
        title: ["Suscripción anual", "suscripción anual"],
      },
      school: {
        title: ["ESCOLAR", "PLAN ESCOLAR", "Para la escuela", "Plan escolar", "plan escolar"],
        requestQuote: "Solicitar presupuesto",
      },
    },
    purchasedFrom: {
      amazon: "en la tienda de Amazon",
      android: "en Google Play",
      ios: "en la tienda de apps de iOS",
      stripe: "en abcya.com",
    },
    student: "Información de acceso para estudiantes",
    submit: "SUSCRIBIRSE",
    terms: `Al hacer clic en ^, declaras que has leído y aceptado nuestras <a href="/condiciones" rel="noopener noreferrer" target="_blank">Condiciones de Uso</a>, <a href="/privacidad" rel="noopener noreferrer" target="_blank">Política de Privacidad</a> y <a href="/condiciones-de-pago" rel="noopener noreferrer" target="_blank">Condiciones de Pago</a>.`,
    thankyou: {
      message:
        "Ya te inscribimos. Pronto recibirás un email con un enlace para que verifiques la dirección de email que usaste para tu cuenta.",
      submit: "¡EMPEZAR A JUGAR!",
      title: "¡Gracias por unirte a ABCya!",
    },
    title: ["Suscribirse", "SUSCRIBIRSE"],
  },
  subscription: ["suscripción"],
  subtotal: ["Subtotal"],
  support: {
    title: "SOPORTE",
  },
  tagline: "¡El líder en juegos educativos para niños!",
  taglineIxl: "Haciendo que las experiencias educativas sean mejores para todos.",
  teacher: ["DOCENTE"],
  terms: {
    title: ["TÉRMINOS Y CONDICIONES", "Condiciones de Uso", "CONDICIONES DE USO"],
  },
  thankyou: ["¡GRACIAS!", "¡Gracias!"],
  tools: {
    category: {
      instructions: "Haz clic en las categorías para activarlas o desactivarlas.",
      title: ["CONTROL DE CATEGORÍAS", "Control de categorías"],
    },
    favorite: {
      instructions: "Para añadir más juegos favoritos,",
      title: ["JUEGOS FAVORITOS", "Juegos favoritos"],
    },
    timer: {
      alert: ["¡Se acabó el tiempo!"],
      hours: "Horas",
      instructions:
        "Programa el temporizador en función de la cantidad de tiempo que quieras pasar en ABCya. Recibirás un mensaje emergente cuando tu tiempo haya terminado.",
      minutes: "Minutos",
      remaining: "Quedan ^ horas, ^ minutos y ^ segundos.",
      remainingNoSeconds: "Quedan ^ horas, ^ minutos.",
      seconds: "Segundos",
      title: ["TEMPORIZADOR", "Temporizador"],
    },
    title: ["HERRAMIENTAS", "Herramientas"],
    upgrade: "Para acceder a esta herramienta,",
  },
  total: ["Total"],
  tpt: {
    title: "TPT",
  },
  unlock: {
    title: ["¡Desbloquea toda la diversión!"],
    message: ["Disfruta de acceso ilimitado a más de 100 juegos de ABCya con una membresía."],
    cta: ["SOLO JUGAR JUEGOS GRATIS"],
  },
  update: ["ACTUALIZAR", "Actualizando", "Actualizado", "Actualizar"],
  upgrade: {
    title: ["SUSCRIBIRSE", "Suscribirse", "Suscribirse", "suscribirse"],
    message: ["Se requiere una membresía para acceder a este contenido. ¡Suscríbete hoy mismo!"],
  },
  verify: {
    login: 'Por favor, <a href="/iniciar-sesion">inicia sesión</a> para continuar.',
    metaTitle: "Verificar dirección de email",
    thankyou: "Gracias por confirmar tu dirección de email.",
    title: "VERIFICAR DIRECCIÓN DE EMAIL",
    verifying: "Verificando",
    notVerified: `Lo siento, hubo problemas para verificar tu dirección de email. Por favor, inténtalo de nuevo o <a href="/soporte">contacta con el servicio al cliente</a>.`,
  },
  vocabulary: {
    title: "Vocabulary.com",
  },
  wyzant: {
    title: "Wyzant",
  },
  yes: ["Sí"],
};

export default strings;
